import React from 'react';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { connect } from 'react-redux';
import { injectIntl, IntlShape, useIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { get } from 'lodash';
import moment from 'moment';
import messages from 'components/AccordionDetail/messages';
import messagesRelSituation from 'components/MyContractInfo/ReleveSituationinfo/messages';
import Header from 'containers/EpargnDetailsPage/ReleveSituation/Header';
import {
  getContractsEpargnSelector,
  getIsLoadingContractEpargnSelector,
} from 'store/contract/selectors';
import MyContractsTabs from 'components/MyContractsTabs';
import {
  renderUnit,
  renderUnitTaux,
  currencyFormat,
  dateFindAn,
} from 'utils/string';
import AccordionReleveSituation from 'components/AccordionReleveSituation';
import SecondAccordionReleve from 'components/SecondAccordionReleve';
import AccordionWithoutExpand from 'components/AccordionWithoutExpand';
import { useSelector } from 'react-redux';
import { isReverse, translate } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import AccordionDetail from 'components/AccordionDetail';
import { SizedSmallSectionHeader } from 'components/MyContractInfo/styles';
import {
  EPARGN_PRODUCT_SCR,
  EPARGN_PRODUCT_SCR_NAME,
} from 'constants/globalConstants';

import AccordionContainer from 'components/AccordionContainer';
import FeatureToggleHOC from 'features/FeatureToggleHOC';
import { FEATURES } from 'features/features';
import {
  RenderVersementsPerYearDetailsXS,
  RenderVersementsPerYearDetailsSM,
  RenderRachatsPerYearDetailsXS,
  RenderRachatsPerYearDetailsSM,
  RenderAvancesPerYearDetailsXS,
  RenderAvancesPerYearDetailsSM,
} from 'containers/EpargnDetailsPage/ReleveSituation/details';
import TooltipDialog from 'components/TooltipDialog';

const ReleveSituation = (props: {
  intl: IntlShape;
  isLoadingContractEpargn: boolean;
  contractsEpargn: {
    infoPolice: {
      NUMERO_POLICE: string;
      PRENOM_ASSURE: string;
      NOM_ASSURE: string;
      DATE_EFFET: string;
      DATE_SITUATION: string;
      CAPITAL_CONSTITUE_SS_PB: string;
      LIBELLE_PRODUIT: string;
      CAPITAL_NET_SS_PB: number;
      CODE_PRODUIT: number;
      PRIMMES_N: number;
      AVANCES_NON_REMBOURSES: number;
      TAUX_FRAIS_CAPITAL: number;
      FRAIS_PRELEVES_CAPITAL: number;
      PB: number;
      CAPITAL_NET_PB: number;
      RP: number;
      SCR_CAPIT_OU_RENTE_GAR: number;
      SCR_PRIM_PAYEES: number;
      SCR_PRIM_A_PAYER: number;
      SCR_PB_REALISE: number;
      SCR_VAL_RACHAT: number;
      SCR_MT_RACHATS_EFFECT: number;
      MONTANT_AVC: number;
      DATE_DEBUT_AVC: string;
      DATE_FIN_AVC: string;
      TAUX_INTERET_AVC: number;
      MONTANT_AVC_NON_REMBOURSE: number;
    };
    cotisations: {
      CODE_PRODUIT: number;
      MONTANT_PRIMES: number;
      DATE_PRIME: string;
    }[];
    prestations: {
      CODE_PRODUIT: number;
      RP_NET: number;
      DATE_RP: string;
      IR_RP: number;
      PENALITE_RP: number;
    }[];
  }[];
}) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const { formatMessage } = useIntl();
  const [tooltipDialogData, setTooltipDialogData] = React.useState({
    open: false,
    title: '',
    description: '',
  });

  /* istanbul ignore next */
  const handleOpen = (title: string, description: string) => (e: Event) => {
    e.stopPropagation();
    if (matches) setTooltipDialogData({ title, description, open: true });
  };

  /* istanbul ignore next */
  const handleClose = () => {
    setTooltipDialogData({ title: '', description: '', open: false });
  };

  const RenderVersementsPerYearDetails = matches
    ? RenderVersementsPerYearDetailsXS
    : RenderVersementsPerYearDetailsSM;
  const RenderRachatsPerYearDetails = matches
    ? RenderRachatsPerYearDetailsXS
    : RenderRachatsPerYearDetailsSM;
  const RenderAvancesPerYearDetails = matches
    ? RenderAvancesPerYearDetailsXS
    : RenderAvancesPerYearDetailsSM;

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Header />
        <MyContractsTabs
          isEpargn={true}
          tabItems={
            props.contractsEpargn &&
            props.contractsEpargn.map((item) => ({
              label:
                get(item, 'infoPolice.CODE_PRODUIT') === EPARGN_PRODUCT_SCR
                  ? EPARGN_PRODUCT_SCR_NAME
                  : get(item, 'infoPolice.LIBELLE_PRODUIT'),
              contractNumber: get(item, 'infoPolice.NUMERO_POLICE'),
              circulationDate: 'circulationDate',
              content: (
                <>
                  {get(item, 'infoPolice.CODE_PRODUIT') ===
                  EPARGN_PRODUCT_SCR ? (
                    <>
                      <AccordionDetail
                        subTitle={formatMessage(messages.CapitalGarantiTitle)}
                        subTitleDescription={formatMessage(
                          messages.CapitalGarantiDescription,
                        )}
                        valueDh={get(item, 'infoPolice.SCR_CAPIT_OU_RENTE_GAR')}
                        secondSubTitle={formatMessage(messages.versementsTitle)}
                        secondsubTitleDescription={formatMessage(
                          messages.versementsDescription,
                        )}
                        secondvalueDh={
                          currencyFormat(
                            get(item, 'infoPolice.SCR_PRIM_PAYEES'),
                          ) +
                          '' +
                          renderUnit(
                            get(item, 'infoPolice.SCR_PRIM_PAYEES'),
                            reverse,
                          )
                        }
                        thirdSubTitle={formatMessage(messages.primeTitle)}
                        thirdsubTitleDescription={formatMessage(
                          messages.primeDescription,
                        )}
                        thirdvalueDh={get(item, 'infoPolice.SCR_PRIM_A_PAYER')}
                      />
                      <AccordionDetail
                        subTitle={formatMessage(messages.participationBenTitle)}
                        subTitleDescription={formatMessage(
                          messages.participationBenDescription,
                        )}
                        valueDh={get(item, 'infoPolice.SCR_PB_REALISE')}
                      />
                      <AccordionDetail
                        subTitle={formatMessage(messages.valeurRachatTitle)}
                        subTitleDescription={formatMessage(
                          messages.valeurRachatDescription,
                        )}
                        valueDh={get(item, 'infoPolice.SCR_VAL_RACHAT')}
                      />
                      <AccordionDetail
                        subTitle={formatMessage(messages.montantRachatTitle)}
                        subTitleDescription={formatMessage(
                          messages.montantRachatDescription,
                        )}
                        valueDh={get(item, 'infoPolice.SCR_MT_RACHATS_EFFECT')}
                      />
                      <AccordionDetail
                        fullWidth
                        subTitle={formatMessage(
                          messages.montantAvanceNonRembourseTitle,
                        )}
                        subTitleDescription={formatMessage(
                          messages.montantAvanceNonRembourseDescription,
                        )}
                        valueDh={get(item, 'infoPolice.SCR_MT_AVC_NON_REMB')}
                      />
                      <AccordionDetail
                        subTitle={formatMessage(
                          messages.montantContreAssuranceTitle,
                        )}
                        subTitleDescription={formatMessage(
                          messages.montantContreAssuranceDescription,
                        )}
                        valueDh={get(item, 'infoPolice.SCR_MT_CTR_ASS')}
                      />
                      <AccordionDetail
                        subTitle={formatMessage(messages.valeurReductionTitle)}
                        subTitleDescription={formatMessage(
                          messages.valeurReductionDescription,
                        )}
                        valueDh={get(item, 'infoPolice.SCR_VAL_REDUCTION')}
                      />
                    </>
                  ) : (
                    <>
                      <SizedSmallSectionHeader color={'#1974FE'} weight="bold">
                        {translate(
                          { ...messagesRelSituation.situationAu },
                          props,
                        )}
                        {moment(
                          get(item, 'infoPolice.DATE_SITUATION'),
                          'YYYY-MM-DD',
                        )
                          .format('DD/MM/YYYY')
                          .toString()}
                      </SizedSmallSectionHeader>

                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <AccordionReleveSituation
                            handleOpenTooltipDialog={handleOpen}
                            epargnConstitue={get(
                              item,
                              'infoPolice.CAPITAL_CONSTITUE_SS_PB',
                            )}
                            epargnNette={get(
                              item,
                              'infoPolice.CAPITAL_NET_SS_PB',
                            )}
                            tauxPreleveEpargn={get(
                              item,
                              'infoPolice.TAUX_FRAIS_CAPITAL',
                            )}
                            fraisCapital={get(
                              item,
                              'infoPolice.FRAIS_PRELEVES_CAPITAL',
                            )}
                            capitalSansParticipation={get(
                              item,
                              'infoPolice.CAPITAL_NET_SS_PB',
                            )}
                            PartiBenificiare={get(item, 'infoPolice.PB')}
                            epargnNettePB={get(
                              item,
                              'infoPolice.CAPITAL_NET_PB',
                            )}
                            expanded={false}
                            handleChange={() => {}}
                          />
                        </Grid>
                        <FeatureToggleHOC feature={FEATURES.NO_ACAPS}>
                          <>
                            <Grid item xs={12}>
                              <SecondAccordionReleve
                                versementsEncours={get(
                                  item,
                                  'infoPolice.PRIMMES_N',
                                )}
                                tauxFrais={get(
                                  item,
                                  'infoPolice.TAUX_FRAIS_CAPITAL',
                                )}
                                fraisPreleve={get(item, 'infoPolice.FRAIS')}
                                versementsNette={get(
                                  item,
                                  'infoPolice.PRIME_NETTE_FRAIS',
                                )}
                                versementsNetteValorise={get(
                                  item,
                                  'infoPolice.PRIMES_NETTES_REV_TMG',
                                )}
                                expanded={false}
                                handleChange={() => {}}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <AccordionWithoutExpand
                                rachatsEncours={get(item, 'infoPolice.RP')}
                                avanceEncours={get(
                                  item,
                                  'infoPolice.AVANCES_NON_REMBOURSES',
                                )}
                              />
                            </Grid>
                          </>
                        </FeatureToggleHOC>
                        <FeatureToggleHOC feature={FEATURES.ACAPS}>
                          <Grid container>
                            <Grid item xs={12}>
                              <AccordionContainer
                                handleOpenTooltipDialog={handleOpen}
                                title={formatMessage(
                                  get(messagesRelSituation, 'versementPerYear'),
                                )}
                                subTitle={
                                  currencyFormat(
                                    get(item, 'infoPolice.PRIMMES_N'),
                                  ) +
                                  '' +
                                  renderUnit(
                                    get(item, 'infoPolice.PRIMMES_N'),
                                    reverse,
                                  )
                                }
                                tooltipText={formatMessage(
                                  get(
                                    messagesRelSituation,
                                    'versementPerYearTooltip',
                                  ),
                                )}
                                details={
                                  <RenderVersementsPerYearDetails
                                    versementsPerYear={get(
                                      item,
                                      'cotisations',
                                      [],
                                    )}
                                    formatMessage={formatMessage}
                                    reverse={reverse}
                                  />
                                }
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <AccordionContainer
                                handleOpenTooltipDialog={handleOpen}
                                title={formatMessage(
                                  get(messagesRelSituation, 'rachatsPerYear'),
                                )}
                                subTitle={
                                  currencyFormat(get(item, 'infoPolice.RP')) +
                                  '' +
                                  renderUnit(
                                    get(item, 'infoPolice.RP'),
                                    reverse,
                                  )
                                }
                                tooltipText={formatMessage(
                                  get(
                                    messagesRelSituation,
                                    'rachatsPerYearTooltip',
                                  ),
                                )}
                                details={
                                  <RenderRachatsPerYearDetails
                                    rachatsPerYear={get(
                                      item,
                                      'prestations',
                                      [],
                                    )}
                                    formatMessage={formatMessage}
                                    reverse={reverse}
                                    handleOpenTooltipDialog={handleOpen}
                                  />
                                }
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <AccordionContainer
                                handleOpenTooltipDialog={handleOpen}
                                title={formatMessage(
                                  get(messagesRelSituation, 'avancesPerYear'),
                                )}
                                subTitle={currencyFormat(
                                  get(
                                    item,
                                    'infoPolice.MONTANT_AVC_NON_REMBOURSE',
                                  ),
                                )}
                                tooltipText={formatMessage(
                                  get(
                                    messagesRelSituation,
                                    'avancesPerYeartooltip',
                                  ),
                                )}
                                details={
                                  <RenderAvancesPerYearDetails
                                    avancesPerYear={get(item, 'infoPolice', {})}
                                    formatMessage={formatMessage}
                                    reverse={reverse}
                                  />
                                }
                              />
                            </Grid>
                          </Grid>
                        </FeatureToggleHOC>
                      </Grid>
                      <SizedSmallSectionHeader color={'#1974FE'} weight="bold">
                        {translate(
                          { ...messagesRelSituation.situationAu },
                          props,
                        )}
                        {dateFindAn(get(item, 'infoPolice.DATE_SITUATION'))}
                      </SizedSmallSectionHeader>

                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <AccordionDetail
                            handleOpenTooltipDialog={handleOpen}
                            subTitle={formatMessage(
                              messagesRelSituation.epargnContituee,
                            )}
                            subTitleDescription={formatMessage(
                              messagesRelSituation.epargnContituee,
                            )}
                            valueDh={get(item, 'infoPolice.CAPITAL_N_1')}
                            secondSubTitle={formatMessage(
                              messagesRelSituation.tauxMinimum,
                            )}
                            secondsubTitleDescription={formatMessage(
                              messagesRelSituation.tauxMinimum,
                            )}
                            secondvalueDh={
                              get(item, 'infoPolice.TMG') +
                              '' +
                              renderUnitTaux(get(item, 'infoPolice.TMG'))
                            }
                            thirdSubTitle={formatMessage(
                              messagesRelSituation.epargnValorisee,
                            )}
                            thirdsubTitleDescription={formatMessage(
                              messagesRelSituation.epargnValorisee,
                            )}
                            thirdvalueDh={get(
                              item,
                              'infoPolice.CAPITAL_N_1_REV_TMG',
                            )}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                  <TooltipDialog
                    open={tooltipDialogData.open}
                    handleClose={handleClose}
                    title={tooltipDialogData.title}
                    description={tooltipDialogData.description}
                  />
                </>
              ),
            }))
          }
          getDetailContract={() => {}}
          isLoadingDetailContract={props.isLoadingContractEpargn}
          category={EVENT_CATEGORIES.EPARGN_DETAILS}
          label="Tab 1: Mes relevés de situation"
        />
      </Grid>
    </Grid>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    contractsEpargn: any;
    isLoadingContractEpargn: boolean;
  }
>({
  contractsEpargn: getContractsEpargnSelector,
  isLoadingContractEpargn: getIsLoadingContractEpargnSelector,
});

export default connect(mapStateToProps, {})(injectIntl(ReleveSituation));
export { ReleveSituation as ReleveSituationTest };
